export class Patient {
  acceptedTerms: boolean;
  avatar: string;
  email: string;
  misc3: string;
  password: string
  parentRelationship: string = '';
  phoneNumber: string;
  planCode: string = '';
  policyNumber: string;
  policyType: number;
  preferences: Preferences = new Preferences;
  profile: Profile = new Profile;
  relationshipCode: string;
  userId: number;
}
export class ChiefComplaints {
  conditionId: number;
  name: string;
  description: string;
  conditionTypeId: number;
}

export class Profile {
  address1: string;
  address2: string;
  city: string;
  dateOfBirth: Date;
  emergencyContactName: string;
  emergencyContactRelationship:string;
  emergencyContactPhone: number;
  day: string = '';
  firstName: string;
  gender: string = '';
  lastName: string;
  middleName: string;
  month: string = '';
  state: string = '';
  suffix: string;
  year: string = '';
  zipCode: string;
  id : number;
}

export class Preferences {
  contactEmail: string;
  contactPhoneNumber: string;
  doseSpotPatientId: number;
  preferredGender: string;
  preferredLanguage: string;
  preferredPharmacyAddress1: string;
  preferredPharmacyAddress2: string;
  preferredPharmacyCity: string;
  preferredPharmacyFax: string;
  preferredPharmacyId: string;
  preferredPharmacyName: string;
  preferredPharmacyPhone: string;
  preferredPharmacyState: string;
  preferredPharmacyZipCode: string;
  timezone: string;
}

export class Provider {
  avatar: string;
  email: string;
  password: string;
  phoneNumber: string;
  profile: Profile = new Profile;
  relationshipCode: string;
  userId: number

}

export class PatientAdditional {
  currentSmoker: boolean;
  smokeStartedSmokingHowLongAgo: number;
  smokeDailyUsage: number;
  alcoholYesNoPast: number;
  alcoholConsumptionType: boolean;
  alcoholDailyConsumption: number;
}

export class PatientPlan {
  planId: number;
  userPolicyId: number;
  visitFee: number;
  name: number;
  planCode: string;
}
export class DisplayPlan {
  planId: number;
  userPolicyId: number;
  visitFee: number;
  name: number;
  planCode: string;
}
export class MedicalCondition {
  name: string;
  conditionTypeId?: number;
  description: string;
  createdById: number;
}
export class ConditionDisplay {
  conditionId: number;
  conditionName_Eng: string;
  conditionName_Esp: string;
  description?: any;
  lineOfBusiness: string;
  sortOrder: number;
}
export class PatientMedicalCondition {
  id: number;
  conditionTypeId: number;
  name: string;
  description: string;
}

export class InsertPatientMedicalHistoryConditionModel
{
    userId: number;
    conditionTypeId: number;
    name: string;
    description: string;
    createdById: number;
}

export class SurgicalList {
  id: number;
  displayName: string;
  fieldName: string;
  yearofsurgery: number;
}

export class PatientFlag {
  flagId: number;
  reasonCodeId: number;
  reasonCode?: any;
  lineOfBusinessId: number;
  lineOfBusinesName?: any;
  patientId: number;
  providerId: number;
  intakeId: number;
  optionalNotes?: any;
  createdById: number;
  createdDate: Date;
  updatedById?: any;
  updatedDate?: any;
}

export class SearchResults {
  id: number;
  firstName: string;
  lastName: string;
  dob: Date;
  group: string;
}

export class PatientAvatarResult {
  avatarCreated: boolean;
}

export class IntakeMedication {
    intakeID: number;
    medicationName: string;
}
export class IntakeAllergen {
    intakeID: number;
    allergenName: string;
}

export class ForgotPasswordResult {
  emailSent: boolean
}

export class PatientActivationInfo {
  isActivated: boolean
}

export class ChangePassword {
  email: string
  password1: string
  password2: string
}
export class Changed {
  EventType: string;
  Subject: string;
  Location: string;
  StartTime: Date;
  EndTime: Date;
  IsAllDay: boolean;
  Description: string;
  RecurrenceException: string;
  RecurrenceRule: string;
  Id: number;
  CategoryColor: string;
}

export class Added {
  EventType: string;
  Subject: string;
  Location: string;
  StartTime: Date;
  EndTime: Date;
  IsAllDay: boolean;
  Description: string;
  RecurrenceException?: any;
  RecurrenceRule: string;
  Id: number;
  CategoryColor: string;
  AllDay: boolean;
  StartTimezone?: any;
  EndTimezone?: any;
  RecurrenceId: number;
}

export class SavePatientSchedule {
  changed: Changed[];
  added: Added[];
  deleted: any[];
  value: Added;
  action: string;
  providerId: number;
}
export class PatientPlanTypes {
  planTypeCode: string;
  planTypeName: string;
}
export class ScheduledIntakeData {
   intakeId: number;
   providerId: number;
   isScheduled: boolean; 
  appointmentDate: string;

}
export class ProviderScheduleSearch {
  startDate: Date;
  endDate: Date;
  stateAbbr: string;
  lineOfBusiness: string;
  providerId: number;
}
export class AvailableProviderQueue {
  providerScheduledAvailabilityId: number;
  providerId: number;
  priority: boolean;
  visitType: string;
  status: string;
  fullName: string;
  shiftStart: string;
  shiftEnd: string;
  license: string;
  licenseType: string;
  licenseNumber: string;
  phsProvider: boolean;
  nmMedicaidProvider: boolean;
  overflow: boolean;
  primaryPhone: string;
  secondaryPhone: string;
  contactPreference: string;
  email: string;
  providerNotes: string;
}
export class ProviderScheduleForPatient {
  eventType: string;
  categoryColor: string
  subject: string;
  location: string;
  startTime: Date;
  endTime: Date;
  allDay: boolean;
  isAllDay: boolean;
  startTimezone?: any;
  endTimezone?: any;
  description: string;
  recurrenceRule: string;
  recurrenceException: string;
  id: number;
  lineOfBusiness: string;
  providerId: string;
}
export class CreateScheduleRequest {
  availabilityId: number;
  scheduleId: number;
  availabilityType: string;
  intakeId: number;
  externalIntakeId: string;
  lineOfBusiness: string;
  specialtyType: string;
  stateAbbr: string;
  startDate: Date;
  endDate: Date;
  providerId: number;
  patientId: number;
  patrnerId: number;
}

